import { render } from "./MediaNews.vue?vue&type=template&id=57e5a715&ts=true"
import script from "./MediaNews.vue?vue&type=script&lang=ts"
export * from "./MediaNews.vue?vue&type=script&lang=ts"

import "./MediaNews.vue?vue&type=style&index=0&id=57e5a715&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__